import { SpecialEventDto, } from "../../../../services/schedulers/types";
import { TSpecialEvent } from "../types";
import { TDailyScheduleEntryExtensions } from "./TDailyScheduleEntryExtensions";

export class TSpecialEventExtensions {
    static fromDtos(items: SpecialEventDto[]): TSpecialEvent[] {
        return items.map((v, i) => {
            const itemsWithEmpty = TDailyScheduleEntryExtensions.fromDtos(v.entries, 1)
            return { entries: itemsWithEmpty, eventPriority: v.eventPriority, calendarEntry: v.calendarEntry, calendarReference: v.calendarReference }
        })
    }

    static toDtos(items: TSpecialEvent[]): SpecialEventDto[] {
        return items.map(v => this.toDto(v));
    }
    static toDto(item: TSpecialEvent): SpecialEventDto {
        return { entries: TDailyScheduleEntryExtensions.toDtos(item.entries), eventPriority: item.eventPriority, calendarEntry: item.calendarEntry, calendarReference: item.calendarReference }
    }

}